/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 
 */


// Shipping rate calculator
document.addEventListener("DOMContentLoaded", async()=>{
  document.querySelectorAll(`[name="country"]`).forEach((elem)=>{
    elem.addEventListener("change", (event)=>{
      const newEvent = new CustomEvent('shipping_country:change');
      document.dispatchEvent(newEvent);
    })
  })
  document.querySelectorAll(`[action="/cart/shipping_rates.json"]`).forEach((form)=>{
    form.addEventListener("submit", async(event)=>{
      event.preventDefault()

      const formData = new FormData(event.target);
      let formEelem = event.target
      const formDataObj = {};

      formEelem.classList.add("loading")
      

      for (const [key, value] of formData.entries()) {
        formDataObj[key] = value;
      }
      if(!formDataObj.zip || !formDataObj.country )return

      let provinceQS=""
      if(formDataObj.province){
        provinceQS=`&shipping_address[province]=${formDataObj.province}`
      }

      try{
        let response = await fetch(`/cart/shipping_rates.json?shipping_address[zip]=${formDataObj.zip}&shipping_address[country]=${formDataObj.country}${provinceQS}`);
        if(response.ok){
          let data = await response.json()
          document.querySelectorAll(".shipping-estimator__results").forEach((esc) => {
            esc.innerHTML = ""
            esc.style.display = "block"
            var labels = ["Ground", "3-Day", "Overnight"];
            var icons = ["truck", "fast", "overnight"];
            if (!data.shipping_rates || data.shipping_rates.length === 0) {
              esc.innerHTML = '<div class="ble-rates__empty">No rates available for this address.</div>';
              return;
            }
            var cardsHtml = '<div class="ble-rates"><div class="ble-rates__title">Available shipping rates</div><div class="ble-rates__list">';
            data.shipping_rates.forEach(function (rate, index) {
              var label = labels[index] || rate.name || ("Option " + (index + 1));
              var iconKey = icons[index] || "truck";
              var priceNum = parseFloat(rate.price);
              var priceFmt = isNaN(priceNum)
                ? rate.price
                : priceNum.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
              var symbol = esc.getAttribute("symbol") || "$";
              var iconSvg = '';
              if (iconKey === "truck") iconSvg = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="6" width="13" height="11" rx="1"/><path d="M14 9h4l3 3v5h-7z"/><circle cx="6" cy="19" r="2"/><circle cx="18" cy="19" r="2"/></svg>';
              else if (iconKey === "fast") iconSvg = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="13 2 13 13 19 13 11 22 11 13 5 13 13 2"/></svg>';
              else if (iconKey === "overnight") iconSvg = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>';
              cardsHtml += '<div class="ble-rates__card">' +
                '<span class="ble-rates__icon">' + iconSvg + '</span>' +
                '<span class="ble-rates__label">' + label + '</span>' +
                '<span class="ble-rates__price">' + symbol + priceFmt + ' <span class="ble-rates__currency">' + rate.currency + '</span></span>' +
              '</div>';
            });
            cardsHtml += '</div></div>';
            esc.innerHTML = cardsHtml;
          });
        }
      }catch(error){
        console.log(error)
      }

      formEelem.classList.remove("loading")
    })
  })

  
  const newEvent = new CustomEvent('shipping_country:change');
  document.dispatchEvent(newEvent);
})




document.addEventListener("shipping_country:change", async()=>{

  let countries = null
  try{
    let res = await fetch('https://raw.githubusercontent.com/muscled-clients/countries/main/countries.json')
    if (res.ok) {
      countries = await res.json()
    }
  } catch(error){
    console.log(error)
  }
  
  if(!countries)return
  document.querySelectorAll(`[name="country"]`).forEach((elem)=>{
    
    let selectElement = document.querySelector(`#${elem.getAttribute("location")}`) || null;
    if(!selectElement)return
    selectElement.innerHTML = ""
    
    countries.forEach((country)=>{
      if(country.country.toLowerCase() == elem.value.toLowerCase() || country.short.toLowerCase() == elem.value.toLowerCase()) {
        
        let provinces = country.provinces
        let provinces_wrapper=selectElement.closest('.form__input-wrapper')

        if (provinces.length <= 0) {
          selectElement.disabled = true
          
          if(provinces_wrapper){
            provinces_wrapper.style.display="none"
          }
        }else{
          selectElement.disabled = false
          if(provinces_wrapper){
            provinces_wrapper.style.display="block"
          }
          provinces.forEach((province)=>{
            const option = document.createElement('option');
            option.value = province.short;
            option.text = province.name;
  
            selectElement.appendChild(option);
          })
        }
      }
    })
  })
})


// Uncheck terms & conditions checkbox when app injects it (not on user click).
// Only fires on childList mutations (new nodes added), so user can still manually check it.
$(document).ready(function(){
  function uncheckNewTermsCheckboxes() {
    $('input[type="checkbox"]').each(function() {
      if (!this.checked) return;
      var text = ($(this).parent().text() || '') + ' ' + ($(this).next('label').text() || '') + ' ' + ($('label[for="' + this.id + '"]').text() || '');
      if (text.indexOf('Terms') !== -1 || text.indexOf('I accept') !== -1) {
        this.checked = false;
        this.removeAttribute('checked');
      }
    });
  }

  new MutationObserver(function(mutations) {
    var hasNewNodes = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) { hasNewNodes = true; break; }
    }
    if (!hasNewNodes) return;
    uncheckNewTermsCheckboxes();
    setTimeout(uncheckNewTermsCheckboxes, 300);
  }).observe(document.body, { childList: true, subtree: true });
});

$(document).ready(function(){
  mobileOnlySlider(".mySlider", true, false, 767);

  function mobileOnlySlider($slidername, $dots, $arrows, $breakpoint) {
    var slider = $($slidername);
    var settings = {
      mobileFirst: true,
      dots: $dots,
      arrows: $arrows,
      responsive: [
        {
          breakpoint: $breakpoint,
          settings: "unslick"
        }
      ]
    };

    slider.slick(settings);

    $(window).on("resize", function () {
      if ($(window).width() > $breakpoint) {
        return;
      }
      if (!slider.hasClass("slick-initialized")) {
        return slider.slick(settings);
      }
    });
  } // Mobile Only Slider
  
  
	//installer page tab
	$('ul.tabs li').click(function(){
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
	})

});